export default "__VITE_ASSET__D7M4BPKp__"